import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BrandMark } from "../../pages/AuthLayout";
import { useT, LanguageToggle } from "./i18n";

export default function SiteHeader() {
  const { t } = useT();
  const [solid, setSolid] = useState(false);
  useEffect(() => {
    const on = () => setSolid(window.scrollY > 40);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  const nav = [
    [t.nav.professions, "#professions", false, "professions"],
    [t.nav.community, "/community", true, "community"],
    [t.nav.jobs, "#jobs", false, "jobs"],
    [t.nav.how, "#how", false, "how"],
  ];

  return (
    <header data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-40 transition-colors duration-300 ${
        solid ? "bg-[#173A2C]/95 backdrop-blur-md shadow-[0_8px_30px_-18px_rgba(0,0,0,.6)]" : "bg-transparent"
      }`}>
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4">
        <BrandMark light />
        <nav className="hidden items-center gap-1 lg:flex">
          {nav.map(([label, href, route, key]) =>
            route ? (
              <Link key={key} to={href} data-testid={`nav-${key}`} className="rounded-full px-3.5 py-2 text-sm text-white/85 transition-colors hover:text-white">{label}</Link>
            ) : (
              <a key={key} href={href} data-testid={`nav-${key}`} className="rounded-full px-3.5 py-2 text-sm text-white/85 transition-colors hover:text-white">{label}</a>
            )
          )}
        </nav>
        <div className="flex items-center gap-2">
          <LanguageToggle testid="header-lang-toggle" />
          <Link to="/login" data-testid="nav-login" className="hidden rounded-full px-4 py-2 text-sm text-white/90 transition-colors hover:text-white sm:inline-block">{t.nav.signin}</Link>
          <Link to="/register" data-testid="nav-register" className="rounded-full bg-[#C4A46B] px-4 py-2 text-sm font-semibold text-[#173A2C] transition-transform hover:-translate-y-0.5">{t.nav.join}</Link>
        </div>
      </div>
    </header>
  );
}
